import ScrollPage, { SectionItem } from "../../Components/ScrollPage/ScrollPage";
import Section from "../../Components/Section/Section";
import "./pipeDriveEmbed.css";

interface ScrollTo {
    index: number;
}

export const Sections: SectionItem[] = [
    { label: "Pipedrive", id: "pipedrive" }
];


const PipeDriveEmbed: React.FC<ScrollTo> = ({ index }) => (
    // you can also get rid of everything and just imitate the espec page you have made in espec
    <ScrollPage index={index} sections={Sections}>
        <Section section={Sections[0].id}>
            {/* <div className="pipedriveWebForms" data-pd-webforms="https://webforms.pipedrive.com/f/c5jZI5SWsD4TSNg6jMMOxkpecpH2Ar85alT0Hd7EG9tIjhyfDNqdL9P38ujb1dg7sv"><script src="https://webforms.pipedrive.com/f/loader"></script></div>
            <PipedriveForm /> */}
            <div className="pipdrive">
                <iframe
                    src="https://webforms.pipedrive.com/f/c5jZI5SWsD4TSNg6jMMOxkpecpH2Ar85alT0Hd7EG9tIjhyfDNqdL9P38ujb1dg7sv"
                    style={{ border: "none",
                    borderRadius: "16px",
                    overflow: "hidden",
                    boxShadow: "0 8px 24px rgba(255, 255, 255, 0.25)",

                    }}
                    title="Pipedrive Form"
                />
            </div>


        </Section>
    </ScrollPage>
);

export default PipeDriveEmbed;